<template>
  <div :class="{ 'transparent-loader': fullScreen === true }" v-if="visible">
    <div class="loader" :class="{ 'loader--sm': size === 'small' }"></div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: { size: { default: 'large' }, fullScreen: { default: true } },
  created() {
    this.$loader.setContainer(this);
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      $('body').addClass('stop-scrolling');
      this.visible = true;
    },
    hide() {
      $('body').removeClass('stop-scrolling');
      this.visible = false;
    },
  },
};
</script>
